import { Typography } from '@mui/material';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConnectedTextField } from 'shared/components';

import { MAX_FREE_TEXT_LENGTH } from '../../../constants';
import { DeclineFeedbackFormData } from '../../../types';

interface FieldFreeTextProps {
    control: Control<DeclineFeedbackFormData, unknown, DeclineFeedbackFormData>;
}

export default function FieldFreeText({ control }: FieldFreeTextProps) {
    const { t } = useTranslation('feedback', { keyPrefix: 'declineDialog.setReasonDetails.freeText' });

    return (
        <>
            <Typography variant="subtitle2">{ t('title') }</Typography>

            <ConnectedTextField control={ control }
                label={ t('label') }
                placeholder={ t('placeholder') }
                name="freeText"
                multiline
                minRows={ 3 }
                slotProps={{
                    htmlInput: {
                        maxLength: MAX_FREE_TEXT_LENGTH
                    }
                }} />
        </>
    );
}
